import { Directive, EventEmitter, Input } from '@angular/core';

@Directive()
export abstract class GridDrawerComponent<TEntity, TOutputEntity = TEntity> {
  @Input() model: TEntity | undefined;
  @Input() isEdit!: boolean;
  @Input() modelChange = new EventEmitter<{
    model: TOutputEntity;
    prevModel: TOutputEntity;
    isValid: boolean;
  }>();
}
